import { ConfigProvider, Dropdown, type DropdownProps, Space } from 'antd';
import UserIcon from '../../assets/icons/user.svg?react';
import { DownOutlined } from '@ant-design/icons';

import './UserMenu.less';

export interface UserMenuProps {
  userUpn?: string;
}

export const UserMenu = ({ userUpn, ...rest }: UserMenuProps & DropdownProps) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Dropdown: {
            controlItemBgHover: '#EAECEE',
            controlPaddingHorizontal: 16,
            paddingBlock: 12,
          },
        },
      }}
    >
      <Dropdown arrow={true} trigger={['click']} {...rest}>
        <Space>
          <UserProfile userUpn={userUpn} />
          <DownOutlined />
        </Space>
      </Dropdown>
    </ConfigProvider>
  );
};

const UserProfile = ({ userUpn }: { userUpn?: string }) => {
  return (
    <div className="user-profile">
      <span>
        <UserIcon />
      </span>
      <span className="text-ellipsis">{userUpn || ''}</span>
    </div>
  );
};

export default UserMenu;
